import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ListWrapperResponse } from '@ip-only/front-end-library';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ConstructionDefinition } from '../definitions/definitions.service';

const constructionDefinitionUrl = `${environment.spanProgressApiUrl}/definitions`;

@Injectable({ providedIn: 'root' })
export class DefinitionsApiService {
  constructor(private readonly http: HttpClient) {}

  fetchDefinitions(definitionType: string) {
    return this.http
      .get<
        ListWrapperResponse<ConstructionDefinition>
      >(`${constructionDefinitionUrl}/${definitionType}`)
      .pipe(map((response) => response.items));
  }
}
